import { LinearProgress, withStyles } from '@material-ui/core';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 5,
    marginTop: 4,
    marginBottom: 4
  },
  colorPrimary: {
    backgroundColor: '#4d4d4d'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#b3b3b3'
  }
}))(LinearProgress);

export default BorderLinearProgress;
